import React, { useState, useEffect } from "react";
import { Card, Button, Input, Modal, List, Space, message, notification, Select, Tooltip, Spin } from "antd";
import '../Masters/Courses/ManageCourse/ManageCourse.css';
import { PlusOutlined, DeleteOutlined, EditOutlined, InboxOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from 'react-router-dom'
import { AssesmentUrl, BaseUrl, ImageGenUrl, REACT_APP_ACESS_KEY_ID, REACT_APP_SECRET_ACESS_KEY, manualGenUrl } from '../Constants/Constants';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Row, Col, Upload } from 'antd';
import axios from 'axios';
import AWS from 'aws-sdk'
import { useLocation } from "react-router-dom";
import { uploadToS3, fetchFileFromS3 } from "../Functions/AWSFunction";


import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Switch from "@mui/material/Switch";


const { Dragger } = Upload;
const { Option } = Select;
const { TextArea } = Input;

const Coursedetail = () => {

    const location = useLocation();


    const [SelectedCourseId, setSelectedCourseId] = useState(null)
    const { courseId: courseIdParam } = useParams(); // from URL
    useEffect(() => {
        // Prefer location state first, fallback to URL param
        if (location.state?.courseId) {
            setSelectedCourseId(location.state.courseId);
        } else if (courseIdParam) {
            setSelectedCourseId(courseIdParam);
        }
    }, [location.state, courseIdParam]);

    // Now SelectedCourseId is guaranteed to have the UUID
    console.log("Selected Course ID:", SelectedCourseId);

    const s3 = new AWS.S3();

    const profileData = JSON.parse(localStorage.getItem("Profile"));
    const userEmail = profileData.email;

    const [Data, setData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [Loading, setLoading] = useState(false)
    const [showTable, setshowTable] = useState(false)
    const [CourseData, setCourseData] = useState([])
    const [assessmentId, setAssessmentId] = useState('')
    const [courseName, setCourseName] = useState('')

    const [isActive, setIsActive] = useState(true);

    const { courseId } = useParams();

    const [parts, setParts] = useState([]);
    const [assessment, setAssessment] = useState([]);

    const [api, contextHolder] = notification.useNotification();

    const [LoadTable, setLoadTable] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [EditAssessmentData, setEditAssessmentData] = useState(null);

    const [isPartModalOpen, setIsPartModalOpen] = useState(false);
    const [isTopicModalOpen, setIsTopicModalOpen] = useState(false);
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewFileData, setPreviewFileData] = useState(null);

    const [currentPartId, setCurrentPartId] = useState(null);
    const [editingTopic, setEditingTopic] = useState(null);
    const [editingQuestion, setEditingQuestion] = useState(null);

    const [partName, setPartName] = useState("");
    const [topicTitle, setTopicTitle] = useState("");
    const [topicContent, setTopicContent] = useState("");
    const [tempFile, setTempFile] = useState(null);
    const [questionText, setQuestionText] = useState("");
    const navigate = useNavigate();
    const [saveAllow, setSaveAllow] = useState(false);
    const [assessmentType, setAssessmentType] = useState(null);
    const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);

    const [assessmentName, setAssessmentName] = useState("");
    const [assessmentLevel, setAssessmentLevel] = useState("");
    const [NumberOfQuestions, setNumberOfQuestions] = useState("");
    const [mcqQuestionsCount, setMcqQuestionsCount] = useState("");
    const [trueOrFalseQuestions, setTrueOrFalseQuestions] = useState("");
    const [multipleAnswer, setMultipleAnswer] = useState("");
    const [matchingListQuestions, setMatchingListQuestions] = useState("");
    const [fillBlankQuestions, setFillBlankQuestions] = useState("");
    const [fillblankDescQuestions, setFillBlankDescQuestions] = useState("");
    const [TableQuestions, setTableQuestions] = useState("");
    const [ImageQuestions, setImageQuestions] = useState("");
    const [Duration, setDuration] = useState("");
    const [Status, setStatus] = useState(false);

    const [assessmentTypeId, setAssessmentTypeId] = useState("");

    const [fileList, setFileList] = useState([]);
    const [file, setfile] = useState([]);

    const [questionType, setQuestionType] = useState("");
    const [questionInput, setQuestionInput] = useState("");
    const [editId, setEditId] = useState(null);
    const totalQ = parseInt(NumberOfQuestions, 10);

    const easyCount = totalQ > 0 ? Math.ceil(totalQ / 2) : 0;
    const hardCount = totalQ > 0 ? Math.floor(totalQ / 2) : 0;


    const [questionLevel, setQuestionLevel] = useState("");

    const [BTNLoading, setBTNLoading] = useState(false);
    const [totalQuestions, setTotalQuestions] = useState([]);
    const [isAssessmentEnabled, setIsAssessmentEnabled] = useState(false);

    const [assessmentDetails, setAssessmentDetails] = useState(null);
    const [assessmentLoading, setAssessmentLoading] = useState(false);

    // Edit Assessment Details Modal and API integration states
    const [editAssessmentModalOpen, setEditAssessmentModalOpen] = useState(false);
    const [editAssessmentLoading, setEditAssessmentLoading] = useState(false);
    const [editAssessmentName, setEditAssessmentName] = useState("");
    const [editAssessmentDuration, setEditAssessmentDuration] = useState("");
    const [editAssessmentQuestions, setEditAssessmentQuestions] = useState("");
    const [groupId, setGroupId] = useState(null);

const [isEditAssessment, setIsEditAssessment] = useState(false);

    useEffect(() => {
        const fetchCourseStatus = async () => {
            try {
                const res = await axios.get(`${BaseUrl}career-development/courses/${courseId}/get-status`, {
                    withCredentials: true,
                });
                const { is_completed } = res.data;
                setIsActive(!is_completed); // active if not completed
            } catch (error) {
                console.error('Error fetching course status:', error);
            }
        };

        fetchCourseStatus();
    }, [courseId]);




    // Function to fetch assessment details
    const fetchAssessmentDetails = async () => {
        try {
            setAssessmentLoading(true);
            const res = await axios.get(
                `${AssesmentUrl}get_career_dev_course_assessment_details?course_id=${courseId}`,
                { withCredentials: true }
            );
            console.log('Assessment Details API Response:', res.data);

            if (res.data.status === 200) {
                // API returns assessments array directly in response
                if (res.data.assessments && Array.isArray(res.data.assessments) && res.data.assessments.length > 0) {
                    console.log('Setting assessment details:', res.data.assessments[0]);
                    setAssessmentDetails(res.data.assessments[0]);
                } else {
                    console.log('No assessments found in response');
                    setAssessmentDetails(null);
                }
            }
            setAssessmentLoading(false);
        } catch (err) {
            console.log('Error fetching assessment:', err);
            setAssessmentDetails(null);
            setAssessmentLoading(false);
        }
    };

    useEffect(() => {
        const fetchAssessmentStatus = async () => {
            try {
                const response = await axios.get(
                    `${AssesmentUrl}career_dev_get_assessment_status`,
                    {
                        params: { course_id: SelectedCourseId }
                    }
                );

                const assessments = response.data.assessments;

                if (assessments && assessments.length > 0) {
                    const status = assessments[0].assessment_status; // "true" or "false"
                    setIsAssessmentEnabled(status === "true");
                } else {
                    setIsAssessmentEnabled(false);
                }
            } catch (error) {
                console.error("Error fetching assessment status:", error);
            }
        };

        if (SelectedCourseId) {
            fetchAssessmentStatus();
        }
    }, [SelectedCourseId]);




    // Fetch assessment details from API when modules are created
    useEffect(() => {
        if (parts.length > 0) {
            fetchAssessmentDetails();
        }
    }, [parts, courseId]);

    // Open modal and prefill values
    const openEditAssessmentModal = () => {
        if (assessmentDetails) {
            setEditAssessmentName(assessmentDetails.assessment_name || "");
            setEditAssessmentDuration(assessmentDetails.assessment_duration || "");
            setEditAssessmentQuestions(assessmentDetails.no_of_questions || "");
        }
        setEditAssessmentModalOpen(true);
    };

    // Handle update API call
    const handleEditAssessmentSave = async () => {
        setEditAssessmentLoading(true);
        try {
            const payload = {
                course_id: courseId,
                assessment_id: assessmentDetails?.assessment_id || '',
                assessment_name: editAssessmentName,
                no_of_question: parseInt(editAssessmentQuestions) || 0,
                assessment_duration: parseInt(editAssessmentDuration) || 0
            };
            console.log('Edit Assessment Payload:', payload);
            const res = await axios.post(`${AssesmentUrl}update_career_dev_assessment_details`, payload, { withCredentials: true });
            if (res.data.status === 200) {
                setAssessmentDetails({
                    assessment_id: assessmentDetails?.assessment_id,
                    assessment_name: editAssessmentName,
                    no_of_questions: parseInt(editAssessmentQuestions),
                    assessment_duration: parseInt(editAssessmentDuration)
                });
                notification.success({ message: 'Assessment updated successfully!' });
                setEditAssessmentModalOpen(false);
            } else {
                notification.error({ message: 'Failed to update assessment.' });
            }
        } catch (err) {
            console.log('Error updating assessment:', err);
            notification.error({ message: 'Error updating assessment.' });
        }
        setEditAssessmentLoading(false);
    };

    const handleToggleAssessment = async () => {
        try {
            const newStatus = !isAssessmentEnabled;

            await axios.post(`${AssesmentUrl}career_dev_assessment_status`, {
                course_id: SelectedCourseId,
                status: newStatus.toString() // "true" / "false"
            });

            setIsAssessmentEnabled(newStatus);
        } catch (error) {
            console.error("Error updating assessment status:", error);
        }
    };



    const resetQuestionForm = () => {
        setQuestionInput("");
        setQuestionType("");
        setQuestionLevel("");
        setOption1("");
        setOption2("");
        setOption3("");
        setOption4("");
        setCorrectOption(null);
        setCorrectOptions([]);
        setTfAnswer(null);
        setEditId(null);
        setBlankAnswers("");
        setMatchingPairs([{ left: "", right: "" }]);
        setImageUrl("");
        setImageAnswer("");
        setTableRows([{ label: "A", text: "", answer: "" }]);
    };

    const [option1, setOption1] = useState("");
    const [option2, setOption2] = useState("");
    const [option3, setOption3] = useState("");
    const [option4, setOption4] = useState("");

    const [correctOption, setCorrectOption] = useState(null); // for single-answer types
    const [correctOptions, setCorrectOptions] = useState([]); // for multiple-answer type
    const [tfAnswer, setTfAnswer] = useState(null); // true / false for TF
    const [blankAnswers, setBlankAnswers] = useState(""); // comma separated answers for fill in the blanks
    const [matchingPairs, setMatchingPairs] = useState([{ left: "", right: "" }]); // column A / B pairs
    const [tableRows, setTableRows] = useState([
        { label: "A", text: "", answer: "" },
    ]); // table questions rows
    const [imageUrl, setImageUrl] = useState(""); // base64 for image-based questions
    const [imageAnswer, setImageAnswer] = useState(""); // answer for image-based questions

    useEffect(() => {
        if (courseId || SelectedCourseId) {
            const idToUse = SelectedCourseId || courseId;
            fetchPartsByCourse(idToUse);
            fetchCourseName(idToUse);
        }
    }, [courseId, SelectedCourseId]);

    const fetchCourseName = async (courseId) => {
        try {
            const res = await axios.get(`${BaseUrl}career-development/courses`, {
                withCredentials: true,
            });

            const course = res.data.find((c) => c.id === courseId);
            if (course) {
                setCourseName(course.title || "");
                setGroupId(course.group_id || null);
            }
        } catch (err) {
            console.error("Error fetching course name:", err);
        }
    };

    const fetchPartsByCourse = async (courseId) => {
        try {
            const res = await axios.post(
                `${BaseUrl}career-course-parts/findOneByCareerCourseId`,
                { career_course_id: courseId },
                { withCredentials: true }
            );

            const partsFromDB = res.data.data;

            const formatted = partsFromDB.map((p) => ({
                partId: p.partId,
                partName: p.partTitle,
                topics:
                    p.training?.map((t) => ({
                        topicId: t.id,
                        topicTitle: t.name,
                        topicContent: t.content || "",
                        // map backend module URL to s3Url for preview button
                        s3Url: t.module || null,
                        // optionally keep file object if needed
                        file: t.module
                            ? { url: t.module, type: t.type, name: t.name }
                            : null,
                    })) || [],
            }));

            setParts(formatted);
        } catch (err) {
            console.error("Error fetching course parts:", err);
            message.error("Failed to load course parts");
        }
    };

    const addMatchingRow = () => {
        setMatchingPairs([...matchingPairs, { left: "", right: "" }]);
    };

    const updateMatchingPair = (index, side, value) => {
        const updated = [...matchingPairs];
        updated[index][side] = value;
        setMatchingPairs(updated);
    };

    const removeMatchingRow = (index) => {
        const updated = matchingPairs.filter((_, i) => i !== index);
        setMatchingPairs(updated.length > 0 ? updated : [{ left: "", right: "" }]);
    };

    const addTableRow = () => {
        const nextCharCode =
            tableRows.length > 0
                ? tableRows[tableRows.length - 1].label.charCodeAt(0) + 1
                : "A".charCodeAt(0);
        const nextLabel = String.fromCharCode(nextCharCode);
        setTableRows([...tableRows, { label: nextLabel, text: "", answer: "" }]);
    };

    const updateTableRow = (index, field, value) => {
        const updated = [...tableRows];
        updated[index][field] = value;
        setTableRows(updated);
    };

    const removeTableRow = (index) => {
        const updated = tableRows.filter((_, i) => i !== index);
        setTableRows(
            updated.length > 0 ? updated : [{ label: "A", text: "", answer: "" }]
        );
    };

    const handleImageFileChange = (info) => {
        const file = info.file && info.file.originFileObj;
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            // result will be base64 data URL
            setImageUrl(reader.result || "");
        };
        reader.readAsDataURL(file);
    };

    const openNotificationWithIconWarning = (type) => {
        api["warning"]({
            message: "Warning!!!",
            description: type,
        });
    };
    const openNotificationWithIconError = (type) => {
        api["error"]({
            message: "Oops!!!",
            description: type,
        });
    };
    const openNotificationWithIconSuccess = (type) => {
        console.log("getsSuccess");
        api["success"]({
            message: "Success!!!",
            description: type,
        });
    };

    const getQuestionTypeLabel = (value) => {
        const found = questionTypeOptions.find((opt) => opt.value === value);
        return found ? found.label : value;
    };

    const levelOptions = [
        { value: "easy", label: "Easy" },
        { value: "medium", label: "Medium" },
        { value: "hard", label: "Hard" },
    ];

    const questionLevelOptions = [
        { value: "easy", label: "Easy" },
        { value: "hard", label: "Hard" },
    ];

    const questionTypeOptions = [
        { value: "mcq", label: "MCQ" },
        { value: "tf", label: "True/False" },
        { value: "multiple_answer", label: "Multiple Answer" },
        { value: "matching_list", label: "Matching List" },
        { value: "fill_blank", label: "Fill in the Blank" },
        { value: "fill_blank_desc", label: "Fill Blank with Description" },
        { value: "table_q", label: "Table Question" },
        { value: "image", label: "Image Question" },
    ];

    // Trigger modal after selecting type
    useEffect(() => {
        if (assessmentType) {
            setIsAssessmentModalOpen(true);
        }
    }, [assessmentType]);

    // Reset type when modal closes
    const handleAssessmentModalClose = () => {
        setIsAssessmentModalOpen(false);
        setAssessmentType(null);
        setAssessmentName("");
        setAssessmentLevel("");
        setNumberOfQuestions("");
        setMcqQuestionsCount("");
        setTrueOrFalseQuestions("");
        setMultipleAnswer("");
        setMatchingListQuestions("");
        setFillBlankQuestions("");
        setFillBlankDescQuestions("");
        setTableQuestions("");
        setImageQuestions("");
        setDuration("");
        setStatus(true);
        setFileList([]);
        setfile([]);
        setTotalQuestions([]);
        resetQuestionForm();
    };

    const handleChange = (value) => {
  setStatus(value);
};

    const handleAddQuestion = () => {
        // Validate basic fields
        if (questionInput.trim() === "") {
            openNotificationWithIconError('Please enter the question text');
            return;
        }

        if (!questionType || questionType.trim() === "") {
            openNotificationWithIconError('Please select a question type');
            return;
        }

        if (!questionLevel || questionLevel.trim() === "") {
            openNotificationWithIconError('Please select a question level (Easy/Hard)');
            return;
        }

        // Type-specific validations
        if (questionType === "tf") {
            if (tfAnswer === null || tfAnswer === undefined) {
                openNotificationWithIconError('Please select the correct answer (True/False)');
                return;
            }
        } else if (questionType === "mcq") {
            const opts = [option1, option2, option3, option4].filter(
                (o) => o && o.trim() !== ""
            );
            if (opts.length < 2) {
                openNotificationWithIconError('Please provide at least 2 options for MCQ');
                return;
            }
            if (!correctOption || correctOption.trim() === "") {
                openNotificationWithIconError('Please select the correct option');
                return;
            }
        } else if (questionType === "multiple_answer") {
            const opts = [option1, option2, option3, option4].filter(
                (o) => o && o.trim() !== ""
            );
            if (opts.length < 2) {
                openNotificationWithIconError('Please provide at least 2 options for multiple answer question');
                return;
            }
            if (!correctOptions || correctOptions.length === 0) {
                openNotificationWithIconError('Please select at least one correct option');
                return;
            }
        } else if (questionType === "fill_blank" || questionType === "fill_blank_desc") {
            if (!blankAnswers || blankAnswers.trim() === "") {
                openNotificationWithIconError('Please provide answers for the blanks');
                return;
            }
            if (!questionInput.includes("____")) {
                openNotificationWithIconError('Please use "Insert Blank" button to add blanks in the question');
                return;
            }
        } else if (questionType === "matching_list") {
            const cleanedPairs = (matchingPairs || []).filter(
                (p) =>
                    p.left && p.left.trim() !== "" && p.right && p.right.trim() !== ""
            );
            if (cleanedPairs.length === 0) {
                openNotificationWithIconError('Please add at least one matching pair');
                return;
            }
        } else if (questionType === "table_q") {
            const cleanedRows = (tableRows || []).filter(
                (r) =>
                    r.text && r.text.trim() !== "" && r.answer && r.answer.trim() !== ""
            );
            if (cleanedRows.length === 0) {
                openNotificationWithIconError('Please add at least one table row with question and answer');
                return;
            }
        } else if (questionType === "image") {
            if (!imageUrl || imageUrl.trim() === "") {
                openNotificationWithIconError('Please upload an image');
                return;
            }
            if (!imageAnswer || imageAnswer.trim() === "") {
                openNotificationWithIconError('Please provide the answer for the image question');
                return;
            }
        }

        // If all validations pass, proceed with adding the question
        let questionData = {
            id:
                editId !== null && totalQuestions.find((q) => q.id === editId)
                    ? editId
                    : totalQuestions.length > 0
                        ? totalQuestions[totalQuestions.length - 1].id + 1
                        : 1,
            type: questionType,
            question: questionInput,
            level: questionLevel,
        };

        if (questionType === "tf") {
            questionData = {
                ...questionData,
                answer: tfAnswer, // true / false
            };
        } else if (questionType === "mcq") {
            const opts = [option1, option2, option3, option4].filter(
                (o) => o && o.trim() !== ""
            );
            questionData = {
                ...questionData,
                options: opts,
                correctAnswers: correctOption ? [correctOption] : [],
            };
        } else if (questionType === "multiple_answer") {
            const opts = [option1, option2, option3, option4].filter(
                (o) => o && o.trim() !== ""
            );
            questionData = {
                ...questionData,
                options: opts,
                correctAnswers: correctOptions || [],
            };
        } else if (
            questionType === "fill_blank" ||
            questionType === "fill_blank_desc"
        ) {
            const blanks = (blankAnswers || "")
                .split(",")
                .map((b) => b.trim())
                .filter((b) => b !== "");
            questionData = {
                ...questionData,
                blanks, // ordered answers for each blank (use "____" in question text)
            };
        } else if (questionType === "matching_list") {
            const cleanedPairs = (matchingPairs || []).filter(
                (p) =>
                    p.left && p.left.trim() !== "" && p.right && p.right.trim() !== ""
            );
            questionData = {
                ...questionData,
                pairs: cleanedPairs,
            };
        } else if (questionType === "table_q") {
            const cleanedRows = (tableRows || []).filter(
                (r) =>
                    r.text && r.text.trim() !== "" && r.answer && r.answer.trim() !== ""
            );
            questionData = {
                ...questionData,
                table_rows: cleanedRows,
            };
        } else if (questionType === "image") {
            questionData = {
                ...questionData,
                image: imageUrl,
                answer: imageAnswer,
            };
        }

        if (editId !== null) {
            // If editing, update the existing question
            setTotalQuestions(
                totalQuestions.map((q) => (q.id === editId ? questionData : q))
            );
        } else {
            // If not editing, add a new question
            setTotalQuestions([...totalQuestions, questionData]);
        }
        resetQuestionForm(); // Clear input after adding/editing
    };

    // Helper function to transform questions to API format
    const transformQuestionsForAPI = (questions) => {
        return questions
            .filter((q) => q.type === "mcq" || q.type === "tf")
            .map((q) => {
                let answer = null;
                let options = {
                    option_a: null,
                    option_b: null,
                    option_c: null,
                    option_d: null,
                };
                if (q.type === "mcq") {
                    if (q.options && q.options.length > 0) {
                        options.option_a = q.options[0] || null;
                        options.option_b = q.options[1] || null;
                        options.option_c = q.options[2] || null;
                        options.option_d = q.options[3] || null;
                    }
                    answer =
                        q.correctAnswers && typeof q.correctAnswers[0] === "string"
                            ? q.correctAnswers[0]
                            : "";
                } else if (q.type === "tf") {
                    options.option_a = "true";
                    options.option_b = "false";
                    options.option_c = null;
                    options.option_d = null;
                    answer = typeof q.answer === "boolean" ? q.answer : false;
                }
                return {
                    question_type: q.type,
                    question: q.question,
                    options,
                    answer,
                    question_level: q.level,
                };
            });
    };

  const handleOk = () => {
    if (assessmentName === '' || assessmentLevel === null || !courseId || Duration === '' || NumberOfQuestions === '') {
        openNotificationWithIconWarning('Please fill all the fields to submit')
    } else {
        const requestedCount = parseInt(NumberOfQuestions, 10);
        if (isNaN(requestedCount) || requestedCount <= 0) {
            openNotificationWithIconWarning('Please enter a valid number of questions');
            return;
        }

        if (totalQuestions.length < requestedCount) {
            openNotificationWithIconWarning(
                `You have added only ${totalQuestions.length} questions. Please add at least ${requestedCount} questions.`
            );
            return;
        }

        const easyQuestions = totalQuestions.filter(q => q.level === 'easy');
        const hardQuestions = totalQuestions.filter(q => q.level === 'hard');

        const easyCount = easyQuestions.length;
        const hardCount = hardQuestions.length;

        let minEasyRequired, minHardRequired;
        if (requestedCount % 2 === 0) {
            minEasyRequired = requestedCount / 2;
            minHardRequired = requestedCount / 2;
        } else {
            minEasyRequired = Math.ceil(requestedCount / 2);
            minHardRequired = Math.floor(requestedCount / 2);
        }

        if (easyCount < minEasyRequired) {
            openNotificationWithIconError(
                `Insufficient Easy Questions! You have added ${easyCount} easy questions but need at least ${minEasyRequired}.`
            );
            return;
        }

        if (hardCount < minHardRequired) {
            openNotificationWithIconError(
                `Insufficient Hard Questions! You have added ${hardCount} hard questions but need at least ${minHardRequired}.`
            );
            return;
        }

        setBTNLoading(true);

        if (assessmentType === 'manual') {

            // ✅ UPDATED: transform questions AND preserve question_id
            const transformedQuestions = transformQuestionsForAPI(totalQuestions).map((q, index) => ({
                ...q,
                question_id: totalQuestions[index]?.question_id // ✅ ADD
            }));

            const manualBody = {
                course_id: courseId,
                assessment_name: assessmentName,
                no_of_questions: parseInt(NumberOfQuestions),
                questions: transformedQuestions,
                assessment_status: String(Status),
                assessment_duration: Duration,
                group_id: groupId
            };

            // ✅ NEW: decide endpoint (edit vs create)
            const hasExistingQuestions = totalQuestions.some(q => q.question_id);

            const apiUrl = hasExistingQuestions
                ? `${AssesmentUrl}update_career_dev_questions`
                : `${AssesmentUrl}add_career_dev_questions`;

            axios.post(apiUrl, manualBody, { withCredentials: true })
                .then((res) => {
                    if (res.data.status === 200) {
                        openNotificationWithIconSuccess(
                            hasExistingQuestions
                                ? 'Assessment Updated Successfully!'
                                : 'Assessment Assigned Successfully!'
                        );

                        setLoadTable(true);
                        setLoading(false);
                        setTotalQuestions([]);
                        setBTNLoading(false);
                        handleAssessmentModalClose();

                        setTimeout(() => {
                            fetchAssessmentDetails();
                        }, 500);
                    } else {
                        openNotificationWithIconError('Error saving questions!');
                        setBTNLoading(false);
                    }
                })
                .catch((err) => {
                    openNotificationWithIconError('Error saving questions!');
                    console.log('[DEBUG] assessment API error:', err);
                    setBTNLoading(false);
                });

        } else {
            openNotificationWithIconWarning('Only manual assessment type is supported!');
            setBTNLoading(false);
        }
    }
};



    const handleEdit = (id) => {
        const questionToEdit = totalQuestions.find((q) => q.id === id);
        if (questionToEdit) {
            setQuestionInput(questionToEdit.question);
            setEditId(id);
            setQuestionType(questionToEdit.type || "tf");
            setQuestionLevel(questionToEdit.level || "");

            // Restore additional fields based on type
            if (questionToEdit.type === "tf") {
                setTfAnswer(questionToEdit.answer ?? null);
                setOption1("");
                setOption2("");
                setOption3("");
                setOption4("");
                setCorrectOption(null);
                setCorrectOptions([]);
            } else if (questionToEdit.type === "mcq") {
                const opts = questionToEdit.options || [];
                setOption1(opts[0] || "");
                setOption2(opts[1] || "");
                setOption3(opts[2] || "");
                setOption4(opts[3] || "");
                setCorrectOption(
                    questionToEdit.correctAnswers &&
                        questionToEdit.correctAnswers.length > 0
                        ? questionToEdit.correctAnswers[0]
                        : null
                );
                setCorrectOptions([]);
                setTfAnswer(null);
            } else if (questionToEdit.type === "multiple_answer") {
                const opts = questionToEdit.options || [];
                setOption1(opts[0] || "");
                setOption2(opts[1] || "");
                setOption3(opts[2] || "");
                setOption4(opts[3] || "");
                setCorrectOptions(questionToEdit.correctAnswers || []);
                setCorrectOption(null);
                setTfAnswer(null);
                setBlankAnswers("");
                setMatchingPairs([{ left: "", right: "" }]);
            } else if (
                questionToEdit.type === "fill_blank" ||
                questionToEdit.type === "fill_blank_desc"
            ) {
                setBlankAnswers(
                    questionToEdit.blanks && Array.isArray(questionToEdit.blanks)
                        ? questionToEdit.blanks.join(", ")
                        : ""
                );
                setOption1("");
                setOption2("");
                setOption3("");
                setOption4("");
                setCorrectOption(null);
                setCorrectOptions([]);
                setTfAnswer(null);
                setMatchingPairs([{ left: "", right: "" }]);
            } else if (questionToEdit.type === "matching_list") {
                setMatchingPairs(
                    questionToEdit.pairs &&
                        Array.isArray(questionToEdit.pairs) &&
                        questionToEdit.pairs.length > 0
                        ? questionToEdit.pairs
                        : [{ left: "", right: "" }]
                );
                setOption1("");
                setOption2("");
                setOption3("");
                setOption4("");
                setCorrectOption(null);
                setCorrectOptions([]);
                setTfAnswer(null);
                setBlankAnswers("");
                setImageUrl("");
                setImageAnswer("");
                setTableRows([{ label: "A", text: "", answer: "" }]);
            } else if (questionToEdit.type === "image") {
                setImageUrl(questionToEdit.image || "");
                setImageAnswer(questionToEdit.answer || "");
                setOption1("");
                setOption2("");
                setOption3("");
                setOption4("");
                setCorrectOption(null);
                setCorrectOptions([]);
                setTfAnswer(null);
                setBlankAnswers("");
                setMatchingPairs([{ left: "", right: "" }]);
                setTableRows([{ label: "A", text: "", answer: "" }]);
            } else {
                // Other types only store question text and type
                setOption1("");
                setOption2("");
                setOption3("");
                setOption4("");
                setCorrectOption(null);
                setCorrectOptions([]);
                setTfAnswer(null);
                setBlankAnswers("");
                setMatchingPairs([{ left: "", right: "" }]);
                setImageUrl("");
                setImageAnswer("");
                setTableRows([{ label: "A", text: "", answer: "" }]);
            }
        }
    };

    const handleDelete = (id) => {
        setTotalQuestions(totalQuestions.filter((q) => q.id !== id));
    };

    // ---------------------
    // ADD/EDIT TOPIC
    // ---------------------
    const handleAddOrEditTopic = () => {
        // Extract actual File object from tempFile
        const fileObj = tempFile?.file || null; // tempFile has nested file property

        if (editingTopic) {
            setParts(
                parts.map((part) =>
                    part.partId === currentPartId
                        ? {
                            ...part,
                            topics: part.topics.map((t) =>
                                t.topicId === editingTopic.topicId
                                    ? {
                                        ...t,
                                        topicTitle,
                                        topicContent,
                                        file: tempFile || t.file,
                                        fileObj: fileObj || t.fileObj, // Store actual File object
                                    }
                                    : t
                            ),
                        }
                        : part
                )
            );
        } else {
            setParts(
                parts.map((part) =>
                    part.partId === currentPartId
                        ? {
                            ...part,
                            topics: [
                                ...part.topics,
                                {
                                    topicId: Date.now(),
                                    topicTitle,
                                    topicContent,
                                    file: tempFile || null,
                                    fileObj: fileObj, // Store actual File object from tempFile.file
                                    s3Url: null, // Will store S3 URL after upload
                                },
                            ],
                        }
                        : part
                )
            );
        }
        resetTopicForm();
    };

    const resetTopicForm = () => {
        setTempFile(null);
        setTopicContent("");
        setTopicTitle("");
        setEditingTopic(null);
        setIsTopicModalOpen(false);
    };

    // ---------------------
    // ADD NEW PART
    // ---------------------
    const handleAddPart = () => {
        setParts([...parts, { partId: null, partName, topics: [] }]);
        setPartName("");
        setIsPartModalOpen(false);
    };

    // ---------------------
    // DELETE PART / TOPIC / QUESTION
    // ---------------------
    const deletePart = (partId) => {
        if (parts[0].partId === partId) {
            message.error("First part cannot be deleted.");
            return;
        }
        setParts(
    parts.map((p) =>
      p.partId === partId
        ? { ...p, isDeleted: true }
        : p
    )
  );
    };
    const deleteTopic = (partId, topicId) =>
         setParts(
    parts.map((p) =>
      p.partId === partId
        ? {
            ...p,
            topics: p.topics.map((t) =>
              t.topicId === topicId
                ? { ...t, isDeleted: true }
                : t
            ),
          }
        : p
    )
  );
    const deleteQuestion = (questionId) =>
        setAssessment(assessment.filter((q) => q.questionId !== questionId));

    // ---------------------
    // EDIT TOPIC
    // ---------------------
    const editTopic = (partId, topic) => {
        setCurrentPartId(partId);
        setEditingTopic(topic);
        setTopicTitle(topic.topicTitle);
        setTopicContent(topic.topicContent);
        setTempFile(topic.file || null);
        setIsTopicModalOpen(true);
    };

    const previewFile = async (fileData) => {
        if (!fileData) return;

        let url, name, fileType;

        if (fileData instanceof File) {
            url = URL.createObjectURL(fileData); // safer than FileReader for large files
            name = fileData.name;
            const ext = name.split(".").pop().toLowerCase();
            fileType =
                ext === "pdf"
                    ? "pdf"
                    : ["mp4", "webm", "ogg"].includes(ext)
                        ? "video"
                        : "image";
        } else if (typeof fileData === "string" && fileData.startsWith("http")) {
            url = fileData;
            name = fileData.split("/").pop().split("?")[0]; // remove query params
            const ext = name.split(".").pop().toLowerCase();
            if (ext === "pdf") fileType = "pdf";
            else if (["mp4", "webm", "ogg"].includes(ext)) fileType = "video";
            else if (["jpg", "jpeg", "png", "gif"].includes(ext)) fileType = "image";
            else fileType = "unknown";
        } else if (typeof fileData === "object" && fileData.url) {
            url = fileData.url;
            name = fileData.name || fileData.url.split("/").pop();
            const ext = name.split(".").pop().toLowerCase();
            if (ext === "pdf") fileType = "pdf";
            else if (["mp4", "webm", "ogg"].includes(ext)) fileType = "video";
            else if (["jpg", "jpeg", "png", "gif"].includes(ext)) fileType = "image";
            else fileType = "unknown";
        } else {
            return; // unsupported format
        }

        setPreviewFileData({ name, type: fileType, url });
        setPreviewModalOpen(true);
    };

    // ---------------------
    // ADD / EDIT ASSESSMENT QUESTION
    // ---------------------
    const handleAddOrEditQuestion = () => {
        if (!questionText.trim()) return message.error("Question cannot be empty");

        if (editingQuestion) {
            setAssessment(
                assessment.map((q) =>
                    q.questionId === editingQuestion.questionId
                        ? { ...q, questionText }
                        : q
                )
            );
        } else {
            setAssessment([...assessment, { questionId: Date.now(), questionText }]);
        }
        setQuestionText("");
        setEditingQuestion(null);
        setIsAssessmentModalOpen(false);
    };

    const editQuestion = (question) => {
        setEditingQuestion(question);
        setQuestionText(question.questionText);
        setIsAssessmentModalOpen(true);
    };

    // ---------------------
    // SAVE ALL CHANGES
    // ---------------------
    const handleSaveChanges = async () => {
        if (!SelectedCourseId) {
            message.error("Course ID not found!");
            return;
        }

        if (parts.length === 0) {
            message.warning("Add at least one part before saving!");
            return;
        }

        const profileData = JSON.parse(localStorage.getItem("Profile"));
        const createdBy = profileData?.email || "unknown";
        const fileUrlMap = {};

        try {
            setLoading(true);
            message.loading({ content: "Saving course parts...", key: "saving" });

            // Helper function to check if a topic already exists
            const isTopicExisting = (topic) => {
                // Topic exists if it has s3Url (was saved before) OR topicId is a string UUID (from backend, not Date.now())
                return !!(
                    topic.s3Url ||
                    (typeof topic.topicId === "string" && topic.topicId.length > 10)
                );
            };

            // Check if there are any existing topics
            const hasExistingTopics = parts.some((part) =>
                part.topics.some((topic) => isTopicExisting(topic))
            );

            // Build DTO helper function
            const buildTopicDto = (topic) => {
                const fileInfo = fileUrlMap[topic.topicId];
                const fileUrl = fileInfo?.s3Url || topic.s3Url || "";

                // Determine trainingModuleType dynamically from file type
                let trainingModuleType = "topic"; // default fallback
                if (topic.file?.type) {
                    // Use type from file object (pdf or mp4)
                    trainingModuleType = topic.file.type;
                } else if (topic.fileObj?.type) {
                    // Derive from File object MIME type
                    if (topic.fileObj.type === "application/pdf") {
                        trainingModuleType = "pdf";
                    } else if (topic.fileObj.type.startsWith("video/")) {
                        trainingModuleType = "mp4";
                    }
                }

                return {
                    trainingModuleName: topic.topicTitle,
                    trainingModuleType: trainingModuleType,
                    trainingModuleDuration: "",
                    trainingModuleFileName: topic.fileObj?.name || topic.topicTitle,
                    trainingModule: fileUrl,
                    isDeleted: !!topic.isDeleted,
                    ...(isTopicExisting(topic) && { trainingModuleId: topic.topicId }), // Include ID for existing topics
                };
            };

            // Build coursePartsTraining
            const coursePartsTraining = parts.map((part, index) => ({
                courseId: SelectedCourseId,
                partNumber: (index + 1).toString(),
                partName: part.partName,
                ...(typeof part.partId === "string" && { partId: part.partId }), // Include partId for updates
                isDeleted: !!part.isDeleted ,  
                training: part.topics.map((topic) => buildTopicDto(topic)),
            }));

            // Prepare FormData
            const formData = new FormData();

            if (hasExistingTopics) {
                // Use update endpoint if any topics exist
                const updateCoursePartDto = {
                    coursePartsTraining,
                    courseId: SelectedCourseId,
                    modifiedBy: createdBy,
                    modifiedAt: new Date(),
                };
                formData.append(
                    "updateCoursePartDto",
                    JSON.stringify(updateCoursePartDto)
                );
            } else {
                // Use addParts endpoint for new topics
                const createCoursePartDto = {
                    coursePartsTraining,
                    parts: [],
                    courseId: SelectedCourseId,
                    partId: "",
                    partTitle: "",
                    partNumber: "",
                    createdBy,
                    modifiedAt: new Date(),
                    modifiedBy: createdBy,
                    trainingModuleName: "",
                    trainingModuleType: "",
                    trainingModuleDuration: "",
                    trainingModule: "",
                };
                formData.append(
                    "createCoursePartDto",
                    JSON.stringify(createCoursePartDto)
                );
            }

            // Append File objects
            parts.forEach((part) => {
                part.topics.forEach((topic) => {
                    if (topic.fileObj instanceof File) {
                        formData.append("files", topic.fileObj);
                    }
                });
            });

            // POST to backend - use update if topics exist, otherwise addParts
            const endpoint = hasExistingTopics
                ? `${BaseUrl}career-course-parts/update`
                : `${BaseUrl}career-course-parts/addParts`;

            const res = await axios.post(endpoint, formData, {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            });

            console.log(
                `✅ ${hasExistingTopics ? "Updated" : "Saved"} successfully:`,
                res.data
            );
            message.success({
                content: "All changes saved successfully!",
                key: "saving",
            });

            // Refresh data from backend
            await fetchPartsByCourse(SelectedCourseId);

            setLoading(false);
        } catch (error) {
            console.error("❌ Error saving course parts:", error);
            message.error(error.message || "Error saving course parts!");
            setLoading(false);
        }
    };

    const handleBack = () => {
        if (saveAllow) {
            message.error("Please save the changes before exit!");
        } else {
            navigate(`/careerdevelopmentcourses`);
        }
    };

    const handleStatusChange = async (checked) => {
        setIsActive(checked); // update UI immediately
        try {
            const res = await axios.post(
                `${BaseUrl}career-development/courses/${courseId}/update-status`,
                { is_completed: !checked }, // toggle logic
                { withCredentials: true }
            );

            console.log('Update response:', res.data); // { is_completed, course_id }
        } catch (error) {
            console.error('Error updating course status:', error);
            setIsActive(!checked); // revert UI if API fails
        }
    };


// ✅ NEW – update questions
// const updateSubmittedQuestions = async (payload) => {
//   return axios.post(
//     `${AssesmentUrl}update_career_dev_questions`,
//     payload
//   );
// };

// ✅ 
const handleEditQuestions = async () => {
  try {
    const res = await axios.post(
      `${AssesmentUrl}fetch_career_dev_questions`,
      { course_id: courseId, group_id: groupId },
      { withCredentials: true }
    );

    const data = res.data;

    const mappedQuestions = data.questions.map((q, index) => ({
      id: index + 1,
      question_id: q.question_id,
      type: q.question_type,
      question: q.question,
      level: q.question_level,
      options:
        q.question_type === "tf"
          ? ["true", "false"]
          : [
              q.options?.option_a,
              q.options?.option_b,
              q.options?.option_c,
              q.options?.option_d,
            ].filter(Boolean),
      correctAnswers: q.answer
        ? [q.answer.toString().toLowerCase()]
        : [],
    }));

    setAssessmentType("manual"); // ✅ CRITICAL FIX
    setAssessmentName(data.assessment_name || "");
    setDuration(data.assessment_duration || "");
    setNumberOfQuestions(data.no_of_questions || "");
    setTotalQuestions(mappedQuestions);
    setStatus(
  data.assessment_status === true ||
  data.assessment_status === "true"
);
    setIsAssessmentModalOpen(true);
  } catch (err) {
    console.error("Failed to fetch submitted questions", err);
    openNotificationWithIconError("Failed to load assessment questions");
  }
};


const mapBackendQuestionsToUI = (questions) => {
  return questions.map((q, index) => ({
    id: index + 1,                 // required by UI
    question_id: q.question_id,    // required for update
    type: q.question_type,         // tf / mcq
    question: q.question,
    level: q.question_level,

    // 🔑 convert backend options object → array
    options:
      q.question_type === "tf"
        ? ["true", "false"]
        : [
            q.options?.option_a,
            q.options?.option_b,
            q.options?.option_c,
            q.options?.option_d,
          ].filter(Boolean),

    // 🔑 UI always expects array
    correctAnswers: q.answer ? [q.answer] : [],
  }));
};



// ✅ EXISTING submit handler (ADD this condition inside)
// const handleSubmitQuestions = async () => {
//   const payload = {
//     course_id: courseId,
//     group_id: groupId,
//     assessment_name: assessmentName,
//     assessment_duration: assessmentDuration,
//     assessment_status: assessmentStatus,
//     no_of_questions: questions.length,
//     questions: questions.map((q) => ({
//       question_id: q.question_id, // undefined for new questions
//       question_type: q.question_type,
//       question: q.question,
//       question_level: q.question_level,
//       options: q.options,
//       answer: q.answer
//     }))
//   };

//   try {
//     if (isEditAssessment) {
//       // ✅ UPDATE
//       await updateSubmittedQuestions(payload);
//     } else {
//       // ✅ EXISTING CREATE (DO NOT CHANGE)
//       await axios.post(
//         `${AssesmentUrl}add_career_dev_questions`,
//         payload
//       );
//     }

//     setIsAssessmentModalOpen(false);
//     setIsEditAssessment(false);
//   } catch (err) {
//     console.error("Submit failed", err);
//   }
// };



    return (
        <div style={{ padding: 24, marginTop: "80px" }}>
            {contextHolder}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 16,
                }}>
                <p className='back'>
                    <span onClick={handleBack} style={{ color: '#4096FF', textDecoration: "underline" }}>
                        Courses
                    </span>
                    <span>
                        <ArrowForwardIosIcon className='arrow' />
                    </span>
                    <span style={{ color: '#454545', textDecoration: "" }}>
                        {courseName || 'Loading...'}
                    </span>
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span
                        style={{
                            fontWeight: 600,
                            color: isActive ? "#2e7d32" : "#d32f2f",
                        }}
                    >
                        {isActive ? "Active" : "Inactive"}
                    </span>

                    <Switch
                        checked={isActive}
                        onChange={(e) => handleStatusChange(e.target.checked)}
                        color="primary"
                    />
                </div>
            </div>
            <Card
                title="Manage Course"
                extra={
                    <Space>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setIsPartModalOpen(true)}
                        >
                            Add Part
                        </Button>

                        {parts.length > 0 && assessment.length === 0 && (
                            <Tooltip title={assessmentDetails ? "Assessment already submitted" : ""}>
                                <Select
                                    placeholder="Add Assessment"
                                    style={{ width: 220 }}
                                    disabled={!!assessmentDetails}
                                    value={assessmentType || null}
                                    onChange={(value) =>
                                        setAssessmentType(value)}
                                >
                                    {/* <Option value="ai_mcq">AI generated MCQ</Option>
                                    <Option value="ai_image">AI generated Image</Option> */}
                                    <Option value="manual">Manual Questions</Option>
                                    {/* <Option value="ai_mcq_desc">AI generated MCQ with Description</Option> */}
                                </Select>
                            </Tooltip>
                        )}
                        {assessmentDetails && (
                            <span style={{ color: '#52c41a', fontWeight: 700 }}>
                                ✓ Assessment Already Submitted
                            </span>
                        )}
                        {assessmentDetails && (
                            <Button onClick={handleEditQuestions}>Edit Questions</Button>
                        )}


                        <Button
                            type="default"
                            onClick={() => navigate(`/careercourseassign/${SelectedCourseId}`)}
                        >
                            Assign Module
                        </Button>

                    </Space>
                }
            >
                {parts.filter(part => !part.isDeleted).map((part, index) => (
                    <Card
                        key={part.partId  || `temp-${index}`}
                        style={{ marginBottom: 16, background: "#fafafa" }}
                        title={<Space><strong>{part.partName}</strong></Space>}
                        extra={index === 0 ? null : <Button danger type="text" icon={<DeleteOutlined />} onClick={() => deletePart(part.partId)} />}
                    >
                        {/* Add Topic */}
                        <Button
                            type="dashed"
                            onClick={() => { setCurrentPartId(part.partId); setEditingTopic(null); setIsTopicModalOpen(true); }}
                            icon={<PlusOutlined />}
                            style={{ marginBottom: 16 }}
                        >
                            Add Topic
                        </Button>

                        {/* Topic List */}
                        <List
                            bordered
                            dataSource={part.topics.filter(topic => !topic.isDeleted)}
                            renderItem={topic => (
                                <List.Item
                                    key={topic.topicId}
                                    actions={[
                                        <Button type="text" icon={<EditOutlined />} onClick={() => editTopic(part.partId, topic)} />,
                                        <Button type="text" danger icon={<DeleteOutlined />} onClick={() => deleteTopic(part.partId, topic.topicId)} />,
                                        (topic.file || topic.s3Url || topic.fileObj) && <Button type="link" onClick={() => previewFile(topic.s3Url || topic.file || topic.fileObj)}>Preview</Button>,
                                    ]}
                                >
                                    <List.Item.Meta title={topic.topicTitle} description={topic.topicContent} />
                                </List.Item>
                            )}
                        />
                    </Card>
                ))}

                {/* Assessment Section */}
                {assessment.length > 0 && (
                    <Card
                        style={{ marginTop: 16, background: "#f0f5ff" }}
                        title="Assessment Section"
                    >
                        <Button
                            type="dashed"
                            onClick={() => {
                                setEditingQuestion(null);
                                setQuestionText("");
                                setIsAssessmentModalOpen(true);
                            }}
                            icon={<PlusOutlined />}
                            style={{ marginBottom: 12 }}
                        >
                            Add Question
                        </Button>

                        <List
                            bordered
                            dataSource={assessment}
                            renderItem={(question) => (
                                <List.Item
                                    key={question.questionId}
                                    actions={[
                                        <Button
                                            type="text"
                                            icon={<EditOutlined />}
                                            onClick={() => editQuestion(question)}
                                        />,
                                        <Button
                                            type="text"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => deleteQuestion(question.questionId)}
                                        />,
                                    ]}
                                >
                                    {question.questionText}
                                </List.Item>
                            )}
                        />
                    </Card>
                )}

                {/* Assessment Details Card - Show only when modules are created */}

                {parts.length > 0 && (
                    <>
                        <Card
                            title="Assessment Details"
                            style={{
                                marginTop: 24,
                                marginBottom: 24,
                                borderRadius: 8,
                                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                            }}
                            loading={assessmentLoading}
                            extra={
                                assessmentDetails && (
                                    //   <Button
                                    //     type="text"
                                    //     icon={
                                    //       <EditIcon style={{ fontSize: 18, cursor: "pointer" }} />
                                    //     }
                                    //     onClick={openEditAssessmentModal}
                                    //     title="Edit Assessment Details"
                                    //   />
                                    <Button
                                        type={isAssessmentEnabled ? "default" : "primary"}
                                        style={{ marginRight: 10 }}
                                        onClick={handleToggleAssessment}
                                    >
                                        {isAssessmentEnabled ? "Assessment Enabled" : "Enable Assessment"}
                                    </Button>



                                )
                            }
                        >
                            {assessmentDetails ? (
                                <div style={{ padding: "12px 0" }}>
                                    <div
                                        style={{
                                            marginBottom: 16,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            paddingBottom: 12,
                                            borderBottom: "1px solid #f0f0f0",
                                        }}
                                    >
                                        <span style={{ fontSize: 14, color: "#595959" }}>
                                            Assessment Name
                                        </span>
                                        <span
                                            style={{
                                                fontSize: 14,
                                                fontWeight: 600,
                                                color: "#262626",
                                            }}
                                        >
                                            {assessmentDetails.assessment_name || "N/A"}
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            marginBottom: 16,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            paddingBottom: 12,
                                            borderBottom: "1px solid #f0f0f0",
                                        }}
                                    >
                                        <span style={{ fontSize: 14, color: "#595959" }}>
                                            Number of Questions
                                        </span>
                                        <span
                                            style={{
                                                fontSize: 14,
                                                fontWeight: 600,
                                                color: "#262626",
                                            }}
                                        >
                                            {assessmentDetails.no_of_questions || 0}
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <span style={{ fontSize: 14, color: "#595959" }}>
                                            Duration
                                        </span>
                                        <span
                                            style={{
                                                fontSize: 14,
                                                fontWeight: 600,
                                                color: "#262626",
                                            }}
                                        >
                                            {assessmentDetails.assessment_duration || "N/A"} min
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <p style={{ color: "#8c8c8c", marginBottom: 0 }}>
                                    No assessment details available yet.
                                </p>
                            )}
                        </Card>

                        {/* Edit Assessment Details Modal */}
                        <Modal
                            title="Edit Assessment Details"
                            open={editAssessmentModalOpen}
                            onCancel={() => setEditAssessmentModalOpen(false)}
                            onOk={handleEditAssessmentSave}
                            confirmLoading={editAssessmentLoading}
                            width={500}
                            style={{ borderRadius: 8 }}
                        >
                            <div style={{ marginBottom: 20 }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: 8,
                                        fontWeight: 600,
                                        fontSize: 14,
                                        color: "#262626",
                                    }}
                                >
                                    Assessment Name
                                </label>
                                <Input
                                    value={editAssessmentName}
                                    onChange={(e) => setEditAssessmentName(e.target.value)}
                                    placeholder={`Current: ${assessmentDetails?.assessment_name || "N/A"
                                        }`}
                                    size="large"
                                    style={{ borderRadius: 4 }}
                                />
                            </div>
                            <div style={{ marginBottom: 20 }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: 8,
                                        fontWeight: 600,
                                        fontSize: 14,
                                        color: "#262626",
                                    }}
                                >
                                    Number of Questions
                                </label>
                                <Input
                                    value={editAssessmentQuestions}
                                    onChange={(e) => setEditAssessmentQuestions(e.target.value)}
                                    placeholder={`Current: ${assessmentDetails?.no_of_questions || 0
                                        }`}
                                    type="number"
                                    size="large"
                                    style={{ borderRadius: 4 }}
                                />
                            </div>
                            <div style={{ marginBottom: 20 }}>
                                <label
                                    style={{
                                        display: "block",
                                        marginBottom: 8,
                                        fontWeight: 600,
                                        fontSize: 14,
                                        color: "#262626",
                                    }}
                                >
                                    Duration (minutes)
                                </label>
                                <Input
                                    value={editAssessmentDuration}
                                    onChange={(e) => setEditAssessmentDuration(e.target.value)}
                                    placeholder={`Current: ${assessmentDetails?.assessment_duration || "N/A"
                                        }`}
                                    type="number"
                                    size="large"
                                    style={{ borderRadius: 4 }}
                                />
                            </div>
                        </Modal>
                    </>
                )}

                {/* Save Changes */}
                {(parts.length > 0 || assessment.length > 0) && (() => {
                    // Check if there are any existing topics
                    const hasExistingTopics = parts.some(part =>
                        part.topics.some(topic => {
                            // Topic exists if it has s3Url (was saved before) OR topicId is a string UUID (from backend, not Date.now())
                            return !!(topic.s3Url || (typeof topic.topicId === 'string' && topic.topicId.length > 10));
                        })
                    );
                    const buttonText = hasExistingTopics ? "Update" : "Save Changes";

                    return (
                        <div style={{ marginTop: 24, textAlign: "center" }}>
                            <Button type="primary" size="large" onClick={handleSaveChanges}>{buttonText}</Button>
                        </div>
                    );
                })()}
            </Card>

            {/* Part Modal */}
            <Modal
                title="Add New Part"
                open={isPartModalOpen}
                onOk={handleAddPart}
                onCancel={() => setIsPartModalOpen(false)}
            >
                <Input
                    placeholder="Enter part name"
                    value={partName}
                    onChange={(e) => setPartName(e.target.value)}
                />
            </Modal>

            {/* Topic Modal */}
            <Modal
                title={editingTopic ? "Edit Topic" : "Add Topic"}
                open={isTopicModalOpen}
                onOk={handleAddOrEditTopic}
                onCancel={resetTopicForm}
                width={700}
            >
                <Input
                    placeholder="Topic title"
                    style={{ marginBottom: 12 }}
                    value={topicTitle}
                    onChange={(e) => setTopicTitle(e.target.value)}
                />
                {/* <Input.TextArea
                    rows={3}
                    placeholder="Topic content"
                    style={{ marginBottom: 16 }}
                    value={topicContent}
                    onChange={(e) => setTopicContent(e.target.value)}
                /> */}

                <Dragger
                    name="file"
                    showUploadList={false}
                    beforeUpload={() => false}
                    maxCount={1}
                    customRequest={({ onSuccess }) => onSuccess("ok")}
                    onChange={(info) => {
                        const fileObj = info.fileList.map((f) => f.originFileObj);
                        if (!fileObj.length) return;
                        const file = fileObj[0];

                        // Validate file type
                        if (file.type === "application/pdf" || file.type === "video/mp4") {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                                const fileType =
                                    file.type === "application/pdf" ? "pdf" : "mp4";
                                // Store both the File object and preview data
                                setTempFile({
                                    name: file.name,
                                    type: fileType,
                                    url: e.target.result,
                                    file: file, // Store the actual File object
                                });
                            };
                            reader.readAsDataURL(file);
                        } else {
                            message.error("Only PDF or MP4 files are supported.");
                        }
                    }}
                >
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Click or drag to upload Topic file</p>
                    <p className="ant-upload-hint">Supported: PDF, MP4</p>
                </Dragger>

                {tempFile && (
                    <p style={{ marginTop: 10, color: "green" }}>
                        Uploaded: <strong>{tempFile.name}</strong>
                    </p>
                )}
            </Modal>

            {/* Assessment Modal */}
            <Modal
                title={
                    assessmentType === "ai_mcq"
                        ? "AI Generated MCQ"
                        : assessmentType === "ai_image"
                            ? "AI Generated Image"
                            : assessmentType === "manual"
                                ? "Manual Questions"
                                : "AI Generated MCQ with Description"
                }
                open={isAssessmentModalOpen}
                onCancel={handleAssessmentModalClose}
                footer={false}
                width={1200}
            >
                <Row gutter={16}>
                    {/* Left Column: Assessment Details */}
                    <Col span={9} style={{ maxWidth: '35%' }}>
                        <h3>Fill in the details</h3>

                        {/* Instructions for Admin */}
                        <div style={{
                            backgroundColor: '#fff1f0',
                            border: '1px solid #ffa39e',
                            borderRadius: '4px',
                            padding: '12px',
                            marginBottom: '20px'
                        }}>
                            <p style={{
                                color: '#ff4d4f',
                                fontWeight: 'bold',
                                marginBottom: '8px'
                            }}>
                                Important Guidelines:
                            </p>
                            <ul
                                style={{
                                    color: '#ff4d4f',
                                    marginBottom: '0',
                                    paddingLeft: '20px'
                                }}
                            >
                                <li>
                                    For even number of questions: equal split between Easy and Hard.
                                </li>
                                <li>
                                    For odd number of questions: extra question goes to Easy.
                                </li>

                                {NumberOfQuestions > 0 && (
                                    <li style={{ marginTop: 8 }}>
                                        <b>
                                            Required Distribution for {NumberOfQuestions} questions →
                                            Easy: {easyCount}, Hard: {hardCount}
                                        </b>
                                    </li>
                                )}

                                <li style={{ marginTop: 8 }}>
                                    <b>Pro Tip:</b> Adding more questions than the minimum helps shuffle
                                    questions across attempts and users, improving fairness.
                                </li>
                            </ul>

                        </div>

                        <p className="Title">Assessment Name</p>
                        <Input
                            placeholder="Assessment Name"
                            value={assessmentName}
                            onChange={(e) => setAssessmentName(e.target.value)}
                            className="EditInput"
                        />

                        {/* <p className="Title">Select Assessment Level</p>
                        <Select
                            value={assessmentLevel}
                            placeholder="Select Level"
                            className="EditInput"
                            onChange={(value) => setAssessmentLevel(value)}
                            options={levelOptions}
                        /> */}

                        {/* Conditional fields for MCQ types */}
                        {(assessmentType === "ai_mcq" ||
                            assessmentType === "ai_mcq_desc") && (
                                <>
                                    <p className="Title">Question Count</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={NumberOfQuestions}
                                        onChange={(e) => setNumberOfQuestions(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">MCQ count</p>
                                    <Input
                                        placeholder="Number of MCQs"
                                        value={mcqQuestionsCount}
                                        onChange={(e) => setMcqQuestionsCount(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">True or False Questions</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={trueOrFalseQuestions}
                                        onChange={(e) => setTrueOrFalseQuestions(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">Multiple Answer Questions</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={multipleAnswer}
                                        onChange={(e) => setMultipleAnswer(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">Matching List</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={matchingListQuestions}
                                        onChange={(e) => setMatchingListQuestions(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">Fill In The Blank</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={fillBlankQuestions}
                                        onChange={(e) => setFillBlankQuestions(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">Fill Blank Description</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={fillblankDescQuestions}
                                        onChange={(e) => setFillBlankDescQuestions(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">Table Question Count</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={TableQuestions}
                                        onChange={(e) => setTableQuestions(e.target.value)}
                                        className="EditInput"
                                    />
                                    <p className="Title">Image Question Count</p>
                                    <Input
                                        placeholder="Number of questions"
                                        value={ImageQuestions}
                                        onChange={(e) => setImageQuestions(e.target.value)}
                                        className="EditInput"
                                    />
                                </>
                            )}

                        <p className="Title">Assessment Duration</p>
                        <Input
                            placeholder="Assessment Duration"
                            value={Duration}
                            onChange={(e) => setDuration(e.target.value)}
                            className="EditInput"
                        />

                        <p className="Title">Status</p>
                        <Select
                            value={Status}
                            className="EditInput"
                            onChange={handleChange}
                            options={[
                                { value: false, label: "Inactive" },
                                { value: true, label: "Active" },

                            ]}
                        />
                    </Col>

                    {/* Right Column: Conditional for Image / Manual */}
                    <Col span={15} style={{ maxWidth: '65%' }}>
                        {assessmentType === "ai_image" && (
                            <>
                                <h3>Upload / Drag Images to Generate Questions</h3>
                                <p className="Title">Upload Image</p>
                                <Dragger
                                    fileList={fileList}
                                    multiple
                                    className="imageUploader"
                                    customRequest={({ file, onSuccess, onError }) => {
                                        const isImage =
                                            file.type.startsWith("image/") &&
                                            file.type !== "image/svg+xml";
                                        if (!isImage) {
                                            openNotificationWithIconError(
                                                "Only image formats except SVG are allowed."
                                            );
                                            return onError("Invalid file type");
                                        }
                                        onSuccess("ok");
                                    }}
                                    onChange={(info) => {
                                        const filteredList = info.fileList.filter(
                                            (file) =>
                                                file.type.startsWith("image/") &&
                                                file.type !== "image/svg+xml"
                                        );
                                        setFileList(filteredList);
                                        setfile(filteredList.map((f) => f.originFileObj));
                                    }}
                                >
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">
                                        Click or drag images to upload
                                    </p>
                                    <p className="ant-upload-hint">
                                        Supported formats: png, jpg, webp
                                    </p>
                                </Dragger>
                            </>
                        )}

                        {assessmentType === "manual" && (
                            <>
                                <Card className="manualAssessmentCard" bordered={false}>
                                    <h3>Add Question</h3>
                                    <p className="Title">Number of Questions to Add</p>
                                    <Input

                                        placeholder="Enter total number of questions"
                                        value={NumberOfQuestions}
                                        onChange={(e) => setNumberOfQuestions(e.target.value)}
                                        className="EditInput"
                                        min="1"
                                    />
                                    <p className="Title">Question Type</p>
                                    <Select
                                        placeholder="Select Question Type"
                                        value={questionType}
                                        onChange={setQuestionType}
                                        className="EditInput"
                                        options={questionTypeOptions}
                                    />
                                    <p className="Title">Question Level</p>
                                    <Select
                                        placeholder="Select Question Level"
                                        value={questionLevel}
                                        onChange={setQuestionLevel}
                                        className="EditInput"
                                        options={questionLevelOptions}
                                    />

                                    <p className="Title">Question</p>
                                    <Input.TextArea
                                        rows={3}
                                        placeholder="Enter question"
                                        value={questionInput}
                                        onChange={(e) => setQuestionInput(e.target.value)}
                                    />

                                    {/* Add other manual question fields dynamically like MCQ options, blanks, matching pairs, table questions, etc. */}

                                    {(questionType === "fill_blank" ||
                                        questionType === "fill_blank_desc") && (
                                            <Button
                                                size="small"
                                                style={{ marginTop: 8, marginBottom: 8 }}
                                                onClick={() =>
                                                    setQuestionInput((prev) =>
                                                        prev ? `${prev} ____ ` : "____ "
                                                    )
                                                }
                                            >
                                                Insert Blank
                                            </Button>
                                        )}

                                    {questionType === "tf" && (
                                        <>
                                            <p className="Title">Correct Answer</p>
                                            <Select
                                                className="EditInput"
                                                placeholder="Select True / False"
                                                value={tfAnswer}
                                                onChange={(val) => setTfAnswer(val)}
                                                options={[
                                                    { value: true, label: "True" },
                                                    { value: false, label: "False" },
                                                ]}
                                            />
                                        </>
                                    )}

                                    {(questionType === "mcq" ||
                                        questionType === "multiple_answer") && (
                                            <>
                                                <p className="Title">Options</p>
                                                <Input
                                                    className="EditInput"
                                                    placeholder="Option 1"
                                                    value={option1}
                                                    onChange={(e) => setOption1(e.target.value)}
                                                />
                                                <Input
                                                    className="EditInput"
                                                    placeholder="Option 2"
                                                    value={option2}
                                                    onChange={(e) => setOption2(e.target.value)}
                                                />
                                                <Input
                                                    className="EditInput"
                                                    placeholder="Option 3 (optional)"
                                                    value={option3}
                                                    onChange={(e) => setOption3(e.target.value)}
                                                />
                                                <Input
                                                    className="EditInput"
                                                    placeholder="Option 4 (optional)"
                                                    value={option4}
                                                    onChange={(e) => setOption4(e.target.value)}
                                                />

                                                {questionType === "mcq" && (
                                                    <>
                                                        <p className="Title">Correct Option</p>
                                                        <Select
                                                            className="EditInput"
                                                            placeholder="Select correct option"
                                                            value={correctOption}
                                                            onChange={(val) => setCorrectOption(val)}
                                                            options={[option1, option2, option3, option4]
                                                                .filter((o) => o && o.trim() !== "")
                                                                .map((o) => ({ value: o, label: o }))}
                                                        />
                                                    </>
                                                )}

                                                {questionType === "multiple_answer" && (
                                                    <>
                                                        <p className="Title">Correct Options</p>
                                                        <Select
                                                            mode="multiple"
                                                            className="EditInput"
                                                            placeholder="Select all correct options"
                                                            value={correctOptions}
                                                            onChange={(vals) => setCorrectOptions(vals)}
                                                            options={[option1, option2, option3, option4]
                                                                .filter((o) => o && o.trim() !== "")
                                                                .map((o) => ({ value: o, label: o }))}
                                                        />
                                                    </>
                                                )}
                                            </>
                                        )}

                                    {(questionType === "fill_blank" ||
                                        questionType === "fill_blank_desc") && (
                                            <>
                                                <p className="Title">Blank Answers</p>
                                                <TextArea
                                                    className="EditInput"
                                                    rows={2}
                                                    placeholder="Enter answers for each blank, separated by commas (e.g. answer1, answer2, answer3)"
                                                    value={blankAnswers}
                                                    onChange={(e) => setBlankAnswers(e.target.value)}
                                                />
                                            </>
                                        )}

                                    {questionType === "matching_list" && (
                                        <>
                                            <p className="Title">Matching Pairs (Olympiad Style)</p>
                                            {matchingPairs.map((pair, index) => (
                                                <Row key={index} gutter={8} style={{ marginBottom: 8 }}>
                                                    <Col span={10}>
                                                        <Input
                                                            className="EditInput"
                                                            placeholder={`Column A - Item ${index + 1}`}
                                                            value={pair.left}
                                                            onChange={(e) =>
                                                                updateMatchingPair(
                                                                    index,
                                                                    "left",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                    <Col span={10}>
                                                        <Input
                                                            className="EditInput"
                                                            placeholder={`Column B - Match ${index + 1}`}
                                                            value={pair.right}
                                                            onChange={(e) =>
                                                                updateMatchingPair(
                                                                    index,
                                                                    "right",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </Col>
                                                    <Col span={4}>
                                                        <Button
                                                            danger
                                                            style={{ marginTop: 4 }}
                                                            onClick={() => removeMatchingRow(index)}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            ))}
                                            <Button type="dashed" onClick={addMatchingRow}>
                                                + Add Pair
                                            </Button>
                                        </>
                                    )}

                                    {questionType === "table_q" && (
                                        <>
                                            <p className="Title">
                                                Table Questions (with S.No and Answers)
                                            </p>
                                            {tableRows.map((row, index) => (
                                                <Row
                                                    key={index}
                                                    gutter={8}
                                                    style={{ marginBottom: 8 }}
                                                    align="middle"
                                                >
                                                    <Col span={2}>
                                                        <span>
                                                            <b>{index + 1}.</b>
                                                        </span>
                                                    </Col>
                                                    <Col span={6}>
                                                        <Input
                                                            className="EditInput"
                                                            placeholder="Label (e.g. A, B)"
                                                            value={row.label}
                                                            onChange={(e) =>
                                                                updateTableRow(index, "label", e.target.value)
                                                            }
                                                        />
                                                    </Col>
                                                    <Col span={10}>
                                                        <Input
                                                            className="EditInput"
                                                            placeholder="Question text for this row"
                                                            value={row.text}
                                                            onChange={(e) =>
                                                                updateTableRow(index, "text", e.target.value)
                                                            }
                                                        />
                                                    </Col>
                                                    <Col span={4}>
                                                        <Input
                                                            className="EditInput"
                                                            placeholder="Ans (e.g. A1, B3)"
                                                            value={row.answer}
                                                            onChange={(e) =>
                                                                updateTableRow(index, "answer", e.target.value)
                                                            }
                                                        />
                                                    </Col>
                                                    <Col span={2}>
                                                        <Button
                                                            danger
                                                            size="small"
                                                            onClick={() => removeTableRow(index)}
                                                        >
                                                            X
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            ))}
                                            <Button type="dashed" onClick={addTableRow}>
                                                + Add Row
                                            </Button>
                                        </>
                                    )}

                                    {questionType === "image" && (
                                        <>
                                            <p className="Title">Upload Image</p>
                                            <Upload
                                                accept="image/*"
                                                showUploadList={false}
                                                beforeUpload={() => false}
                                                onChange={handleImageFileChange}
                                            >
                                                <Button className="manualImageUploadBtn">
                                                    Choose Image
                                                </Button>
                                            </Upload>
                                            <p className="ant-upload-hint" style={{ marginTop: 4 }}>
                                                Supported formats: png, jpg, webp. Image will be saved
                                                as base64.
                                            </p>
                                            {imageUrl && (
                                                <div className="questionImagePreviewWrapper">
                                                    <img
                                                        src={imageUrl}
                                                        alt="Question"
                                                        style={{
                                                            maxWidth: "100%",
                                                            maxHeight: 150,
                                                            borderRadius: 4,
                                                        }}
                                                    />
                                                </div>
                                            )}
                                            <p className="Title" style={{ marginTop: 10 }}>
                                                Answer
                                            </p>
                                            <Input
                                                className="EditInput"
                                                placeholder="Enter correct answer for this image"
                                                value={imageAnswer}
                                                onChange={(e) => setImageAnswer(e.target.value)}
                                            />
                                        </>
                                    )}

                                    <Button
                                        type="primary"
                                        style={{ marginTop: 10 }}
                                        onClick={handleAddQuestion}
                                    >
                                        {editId !== null ? "Save Changes" : "Add Question"}
                                    </Button>
                                </Card>

                                <div style={{ marginTop: 16 }}>
                                    <Row gutter={16}>
                                        {/* Easy Questions Container */}
                                        <Col span={12}>
                                            <Card
                                                className="addedQuestionCardDiv"
                                                bordered={false}
                                            >
                                                <div className="assessmentCardTotalQuestionCard">
                                                    <h3 style={{ color: '#52c41a' }}>Easy ({totalQuestions.filter(q => q.level === 'easy').length})</h3>
                                                    {totalQuestions.filter(q => q.level === 'easy').length === 0 ? (
                                                        <p className="noQuestionDisplay">
                                                            No easy questions yet.
                                                        </p>
                                                    ) : (
                                                        <>
                                                            {totalQuestions.filter(q => q.level === 'easy').map((q) => (
                                                                <Card
                                                                    className="questionSingleCard"
                                                                    key={q.id}
                                                                    size="small"
                                                                    style={{ borderLeft: '4px solid #52c41a', marginBottom: 8 }}
                                                                >
                                                                    <p style={{ marginBottom: 4, fontSize: 12 }}>
                                                                        <b>Q{q.id}.</b> {q.question}
                                                                    </p>
                                                                    <p
                                                                        className="questionTypeText"
                                                                        style={{ marginBottom: 4, fontSize: 11 }}
                                                                    >
                                                                        {getQuestionTypeLabel(q.type)}
                                                                    </p>
                                                                    <EditIcon
                                                                        onClick={() => handleEdit(q.id)}
                                                                        className="questionEditIcon"
                                                                        style={{ fontSize: 14 }}
                                                                    />
                                                                    <DeleteIcon
                                                                        onClick={() => handleDelete(q.id)}
                                                                        className="questionDeleteIcon"
                                                                        style={{ fontSize: 14 }}
                                                                    />
                                                                </Card>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            </Card>
                                        </Col>

                                        {/* Hard Questions Container */}
                                        <Col span={12}>
                                            <Card
                                                className="addedQuestionCardDiv"
                                                bordered={false}
                                            >
                                                <div className="assessmentCardTotalQuestionCard">
                                                    <h3 style={{ color: '#ff7a45' }}>Hard ({totalQuestions.filter(q => q.level === 'hard').length})</h3>
                                                    {totalQuestions.filter(q => q.level === 'hard').length === 0 ? (
                                                        <p className="noQuestionDisplay">
                                                            No hard questions yet.
                                                        </p>
                                                    ) : (
                                                        <>
                                                            {totalQuestions.filter(q => q.level === 'hard').map((q) => (
                                                                <Card
                                                                    className="questionSingleCard"
                                                                    key={q.id}
                                                                    size="small"
                                                                    style={{ borderLeft: '4px solid #ff7a45', marginBottom: 8 }}
                                                                >
                                                                    <p style={{ marginBottom: 4, fontSize: 12 }}>
                                                                        <b>Q{q.id}.</b> {q.question}
                                                                    </p>
                                                                    <p
                                                                        className="questionTypeText"
                                                                        style={{ marginBottom: 4, fontSize: 11 }}
                                                                    >
                                                                        {getQuestionTypeLabel(q.type)}
                                                                    </p>
                                                                    <EditIcon
                                                                        onClick={() => handleEdit(q.id)}
                                                                        className="questionEditIcon"
                                                                        style={{ fontSize: 14 }}
                                                                    />
                                                                    <DeleteIcon
                                                                        onClick={() => handleDelete(q.id)}
                                                                        className="questionDeleteIcon"
                                                                        style={{ fontSize: 14 }}
                                                                    />
                                                                </Card>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>

                                    {/* Total Questions Summary */}
                                    {totalQuestions.length > 0 && (
                                        <div style={{ textAlign: 'center', marginTop: 16, marginBottom: 16 }}>
                                            <p style={{ fontSize: 13, color: '#595959ff', marginBottom: 10 }}>
                                                <b>Total: {totalQuestions.length}</b> (Easy: {totalQuestions.filter(q => q.level === 'easy').length}, Hard: {totalQuestions.filter(q => q.level === 'hard').length})
                                            </p>
                                            <Button
                                                danger
                                                size="small"
                                                className="clearQuestionBtn"
                                                onClick={() => setTotalQuestions([])}
                                                style={{ color: 'white' }}
                                            >
                                                Clear All
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </Col>
                </Row>

                {/* Footer */}
                <Row justify="end" style={{ marginTop: 20 }}>
                    <Button
                        onClick={handleAssessmentModalClose}
                        style={{ marginRight: 10 }}
                    >
                        Cancel
                    </Button>
                    <Tooltip title="After submitting the assessment, you can't edit the assessment details">
                        <Button type="primary" onClick={handleOk} loading={BTNLoading}>
                            Submit
                        </Button>
                    </Tooltip>
                </Row>
            </Modal>

            {/* Preview Modal */}
            <Modal
                title={previewFileData?.name || "Preview"}
                open={previewModalOpen}
                onCancel={() => setPreviewModalOpen(false)}
                footer={null}
                width={previewFileData?.type === "pdf" ? 800 : 600}
            >
                {previewFileData?.type === "pdf" ? (
                    <iframe
                        src={previewFileData.url}
                        style={{ width: "100%", height: "80vh" }}
                        title="PDF Preview"
                    />
                ) : ["video", "mp4"].includes(previewFileData?.type) ? (
                    <video controls style={{ width: "100%" }}>
                        <source src={previewFileData.url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : null}
            </Modal>
        </div>
    );
};

export default Coursedetail;
